export default __webpack_public_path__ + "static/titanwatch-26702785ecb5750c8bd55de566f5ec06.png";